import  React, {useEffect, useState} from "react";
import { Container } from "../styled.ts";
import { Typography } from "../typography/index.tsx";
import { Tick } from "../icons/tick.tsx";

function ResultBar({ result, onSelect }) {
  const [isClicked, setIsClicked] = useState(false);
  let timeOut;
  useEffect(()=>{
    return ()=>{
      clearTimeout(timeOut);
    }
  },[])
  return (
    <Container
      key={result.value}
      onClick={() => {
        setIsClicked(true);
        timeOut = setTimeout(()=>{
          setIsClicked(false);
        },1000)
        onSelect(result);
      }}
      hover
      justifyContent="space-between"
    >
      <Typography
        fontFamily="Neue Montreal"
        fontSize={"14px"}
        fontWeight={500}
        lineHeight={"19.6px"}
        cursor="pointer"
      >
        {result.label}
      </Typography>

      {isClicked && <Tick width="20" height="20" color="green" />}
    </Container>
  );
}

export default ResultBar;
